import { HStack } from '@/components/Atoms'
import { getNextTristateValue, TriStateValue } from '@/lib/utils/tristate'
import { INDETERMINATE } from '@repo/constants'
import { Checkbox, Label } from '@repo/ui/components'
import { Container } from './Container'

type TriStateCheckboxProps = {
  name: string
  title: string
  label: string
  value: TriStateValue
  setValue: React.Dispatch<React.SetStateAction<TriStateValue>>
}

export function TriStateCheckbox(props: TriStateCheckboxProps) {
  const handleCheckboxChange = (value: TriStateValue) => {
    props.setValue(getNextTristateValue(value))
  }

  const handleReset = () => {
    props.setValue(INDETERMINATE)
  }

  return (
    <Container
      isResetVisible={props.value !== undefined && props.value !== INDETERMINATE}
      onReset={handleReset}
      title={props.title}
    >
      <HStack gap="md">
        <Checkbox
          id={props.name}
          checked={props.value ?? INDETERMINATE}
          onCheckedChange={() => handleCheckboxChange(props.value)}
        />
        <Label htmlFor={props.name}>{props.label}</Label>
      </HStack>
    </Container>
  )
}
